import { formatFileSize } from '@fabric-app/utils/number';

const getUpsellTitle = (currentPlan, upsellPlan, entitlement) => {
  switch (entitlement) {
    case "integrationsEnabled":
      return `Unlock data connections`;
    case "bulkImportEnabled":
      return `Unlock bulk imports`;
    case "maxFileSizeMB":
      return `Unlock uploads up to ${formatFileSize(upsellPlan.entitlements.maxFileSizeMB * 1e3 * 1e3)}`;
    case "maxTotalStorageSizeMB":
      return `Unlock ${formatFileSize(upsellPlan.entitlements.maxTotalStorageSizeMB * 1e3 * 1e3)} of storage`;
    case "creditCentsMonthly":
      return `Get ${Math.floor(upsellPlan.entitlements.creditCentsMonthly / currentPlan.entitlements.creditCentsMonthly)}x more thinking credits`;
    case "aiVoiceAndMeetingRecordingEnabled":
      return `Unlock AI voice notes`;
    case "recapsEnabled":
      return `Get recaps`;
    case "audioTranscriptionEnabled":
      return `Get audio and video transcription`;
    case "modelSwitchingEnabled":
      return `Unlock all models & higher limits`;
    default:
      throw new Error(`Unknown entitlement: ${entitlement}`);
  }
};

export { getUpsellTitle };
//# sourceMappingURL=getUpsellTitle.js.map
